import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const parentSelect = this.element.querySelector('select[name*="[parent_id]"]')
    if (parentSelect) {
      this.toggleRequired({ target: parentSelect })
    }
  }

  toggleRequired(event) {
    const hasParent = event.target.value !== ""
    const star = document.getElementById("area-code-required-star")
    const help = document.getElementById("area-code-help")
    const codeInput = document.getElementById("area-code-input")

    if (star) star.style.display = hasParent ? "" : "none"
    if (help) help.style.display = hasParent ? "none" : ""
    if (codeInput) codeInput.required = hasParent
  }
}
